module.exports = {"340222100":"繁阳镇","340222101":"荻港镇","340222102":"孙村镇","340222103":"平铺镇","340222104":"新港镇","340222105":"峨山镇","340222401":"安徽繁昌工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340222.json
// module id = 1052
// module chunks = 0